// extracted by mini-css-extract-plugin
export default {"mapContainer":"SupplyChainMap_mapContainer__qJjqG"};